var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { default as React } from 'react';
import { RadioGroupControl } from '../../Components/RadioGroupControl';
import { InstructionType, MedicationType } from '../../Contracts/MedicationModels';
import { prettyPrintDosageInstructionLabel } from '../../Shared/MedicationSharedMethods';
import { EditMedicationInstructionField, InstructionPositions } from '../FieldSection/EditMedicationDosageInstructionsSection';
import styles from './EditMedicalLabelForm.module.css';
import { SameInstructions } from './useEditDosageInstructionState';
export var WrapInMedicalLabel = function (props) {
    return (React.createElement("div", { className: styles.orderInstructionsContainer },
        props.children,
        React.createElement(EditMedicalLabelForm, __assign({}, props))));
};
export var EditMedicalLabelForm = function (props) {
    var dosageInstructionSameAsOrder = props.form.values.dosageInstructionSameAsOrder;
    var readOnly = !props.isAdjustMedication && props.readOnly;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.sameInstructions },
            prettyPrintDosageInstructionLabel(props.currentMedicationType),
            " same as order instructions",
            React.createElement(RadioGroupControl, { readOnly: readOnly, label: '', value: dosageInstructionSameAsOrder ? SameInstructions.Same : SameInstructions.NotSame, onChange: function (_, value) { return props.changeDosageSameAsOrder(value); }, options: [
                    {
                        label: 'Yes',
                        value: SameInstructions.Same
                    },
                    {
                        label: 'No',
                        value: SameInstructions.NotSame
                    }
                ], removeLastControlMargin: true })),
        !dosageInstructionSameAsOrder && (React.createElement(EditMedicationInstructionField, __assign({}, props, { label: prettyPrintDosageInstructionLabel(props.currentMedicationType), patientId: props.patient.id, readOnly: props.readOnly, isAdjustMedication: props.isAdjustMedication, required: true, requiredRouteOfAdministration: props.currentMedicationType === MedicationType.EnrmcScript, hideFrequency: props.hideFrequency, instructionPosition: InstructionPositions.Dosage, instruction: props.form.values.dosageInstruction, defaultInstructionType: InstructionType.FreeTextInstruction })))));
};
